import React from "react";
import Modal from "react-modal";
import "./style.scss";

import "../../style/block.scss";
import "../../style/buttons.scss";
import "../../style/typography.scss";
import "../../style/feature.scss";

interface IProps {
  open: boolean;
  afterOpenModal?: () => void;
  closeModal: () => void;
  imageUrl?: string;
  onAccept: () => void;
}


const LightBox: React.FC<IProps> = ({
  imageUrl,
  open,
  afterOpenModal = () => {},
  closeModal,
  onAccept,
}: IProps) => {
  return (
    <Modal
      isOpen={open}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      contentLabel="modal"
      className="modal-lightbox"
    >
      <div className="lightbox" onClick={() => closeModal()}>
        <img src={imageUrl} alt="duże zdjęcie"/>
      </div>
    </Modal>
  );
};
Modal.setAppElement("#root");

export default LightBox;
